import { useSelector } from 'react-redux';
import { MdExpandLess, MdExpandMore } from 'react-icons/md';
import { Collapse, List, ListItemButton, Typography } from '@mui/material';

import ItemList from './ItemList';
import { selectDefaultTheme } from 'GeminiViewerComponent/features/globals/themeSlice';

const ZoneList = ({
    index,
    zoneItem,
    item,
    itemSubMenu,
    setItemSubMenu,
    itemProperty,
    linkProperty,
    handleClick,
    handleZoneClick,
    linkKey,
    zoneSubMenu,
    zoneProperty,
    setzoneSubMenu,
    itemKey,
}) => {
    const theme = useSelector(selectDefaultTheme);
    return (
        <List component="div" disablePadding key={index}>
            <ListItemButton
                sx={{ pl: 4 }}
                onClick={(e) => {
                    e.stopPropagation();
                    handleZoneClick(zoneItem, item?.asset_id);
                }}
            >
                <span style={{ color: theme.colors.text, fontWeight: 'bold' }}>Zone:&nbsp;</span>
                <Typography
                    title={zoneItem[zoneProperty]}
                    style={{
                        width: '100%',
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                        margin: '4px 0',
                    }}
                >
                    {zoneItem[zoneProperty]}
                </Typography>
                {zoneSubMenu[index] ? (
                    <MdExpandLess
                        className="react-icon"
                        onClick={(e) => {
                            e.stopPropagation();
                            handleClick(zoneSubMenu, setzoneSubMenu, index);
                        }}
                        style={{ fontSize: '28px' }}
                    />
                ) : (
                    <MdExpandMore
                        className="react-icon"
                        onClick={(e) => {
                            e.stopPropagation();
                            handleClick(zoneSubMenu, setzoneSubMenu, index);
                        }}
                        style={{ fontSize: '28px' }}
                    />
                )}
            </ListItemButton>
            {zoneItem[itemKey] !== undefined && (
                <Collapse in={zoneSubMenu[index]} timeout="auto" unmountOnExit>
                    {zoneItem[itemKey]?.map((hotspotItem, idx) => (
                        <ItemList
                            key={`ItemList-${idx}`}
                            index={idx}
                            linkProperty={linkProperty}
                            linkKey={linkKey}
                            handleClick={handleClick}
                            setItemSubMenu={setItemSubMenu}
                            handleZoneClick={handleZoneClick}
                            zoneItem={zoneItem}
                            item={item}
                            hotspotItem={hotspotItem}
                            itemSubMenu={itemSubMenu}
                            itemProperty={itemProperty}
                        />
                    ))}
                </Collapse>
            )}
        </List>
    );
};

export default ZoneList;
